import React, { useState, forwardRef } from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  ListItemText,
  Typography
} from '@mui/material';
import { getTaskTypes } from '../../../services/timeManagementService';
import { useDispatch } from 'react-redux';
import { AppActions } from 'src/store/AppReducer';
import { TTaskType } from 'src/models/timesheet';

interface TaskTypeDropdownProps {
  value: number;
  onChange: (e: any) => void;
  disabled?: boolean;
  required?: boolean;
}

const TaskTypeDropdown = forwardRef((props: TaskTypeDropdownProps, _ref) => {
  const dispatch = useDispatch();
  const [taskTypeList, setTaskTypeList] = React.useState<TTaskType[]>([]);

  const getTaskApiHandler = () => {
    dispatch(AppActions.showLoader());
    getTaskTypes()
      .then((res) => {
        if (res.data.statusCode === 200) {
          const data: TTaskType[] = res.data?.data?.taskTypes || [];
          const modifyTypes: TTaskType[] = data.filter(
            (item: TTaskType) => item.typeName !== 'COMMON'
          );
          setTaskTypeList(modifyTypes);
        }
        dispatch(AppActions.hideLoader());
      })
      .catch((err) => {
        dispatch(AppActions.hideLoader());
      });
  };

  React.useEffect(() => {
    getTaskApiHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormControl
      fullWidth
      disabled={props?.disabled ? props?.disabled : false}
      className="task-type-dropdown"
    >
      <Typography fontWeight="light" variant="h5" className="input-lable">
        Activity Type{props?.required && <span style={{ color: 'red' }}>*</span>}
      </Typography>
      <Select
        sx={{ mt: '4px' }}
        style={{
          fontSize: '12px',
          height: '2rem'
        }}
        displayEmpty
        size="small"
        value={props?.value}
        onChange={(e) => props?.onChange(e)}
      >
        <MenuItem style={{ display: 'none' }} selected disabled value={''}>
          Select Activity Type
        </MenuItem>
        {taskTypeList?.length > 0 &&
          taskTypeList.map((type, i) => {
            return (
              <MenuItem key={i} value={type.id}>
                <ListItemText primary={type.typeName} />
              </MenuItem>
            );
          })}
      </Select>
    </FormControl>
  );
});

export default TaskTypeDropdown;
